(() => {
  if (customElements.get('jeff-recently-viewed')) return;

  class JeffRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const currentProductData = this.querySelector('[data-current-product]');
      if (!currentProductData) return;

      let currentProduct = null;
      try {
        currentProduct = JSON.parse(currentProductData.textContent);
      } catch (e) {
        return;
      }

      const storageKey = 'jeff_shoes_recently_viewed_v2';
      let recent = [];
      try {
        recent = JSON.parse(localStorage.getItem(storageKey)) || [];
      } catch (e) {
        recent = [];
      }

      // Add current product to front if valid
      if (currentProduct && currentProduct.id && currentProduct.html) {
        recent = recent.filter(p => p.id !== currentProduct.id);
        recent.unshift(currentProduct);
        if (recent.length > 8) recent = recent.slice(0, 8);
        try {
          localStorage.setItem(storageKey, JSON.stringify(recent));
        } catch (e) {}
      }

      // Filter out current product for display
      const displayProducts = recent.filter(p => p.id !== currentProduct.id);
      const container = this.querySelector('[data-recent-grid]');

      if (!container) return;

      const sectionWrapper = this.closest('.jeff-section') || this;
      if (displayProducts.length === 0) {
        sectionWrapper.style.display = 'none';
        return;
      }

      sectionWrapper.style.display = '';
      container.innerHTML = '';

      displayProducts.slice(0, 4).forEach(prod => {
        if (prod.html) {
          container.insertAdjacentHTML('beforeend', prod.html);
        } else if (prod.title && prod.image) {
          // Fallback graceful para datos cacheados en formato anterior
          const priceFormatted = '$' + (prod.price / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
          let compareHtml = '';
          if (prod.compare_at_price > prod.price) {
            const compFormatted = '$' + (prod.compare_at_price / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
            compareHtml = `<s>${compFormatted}</s>`;
          }

          const fallbackHtml = `
            <article class="jeff-product" data-jeff-product-card>
              <a href="${prod.url}" class="jeff-product__media jeff-product__media--portrait" data-jeff-product-link aria-label="${prod.title}">
                <img data-jeff-product-image src="${prod.image}" width="300" height="375" alt="${prod.title}" loading="lazy">
              </a>
              <div class="jeff-product__details">
                <h3><a href="${prod.url}" data-jeff-product-link>${prod.title}</a></h3>
                <div class="jeff-product__price">
                  <span>${priceFormatted}</span>
                  ${compareHtml}
                </div>
              </div>
            </article>
          `;
          container.insertAdjacentHTML('beforeend', fallbackHtml);
        }
      });
    }
  }

  customElements.define('jeff-recently-viewed', JeffRecentlyViewed);
})();
